<template>
  <div id="totalBox">
    <div class="relationBox">
      <p class="relationTitle">联系我们</p>
      <div class="relationWayBox">
        <div class="relationWay">
          <img src="../../assets/about/phone.png" class="relationIcon"/>
          <p class="relationWayTitle">联系电话</p>
          <p class="relationWayContent">400-1518-788</p>
        </div>
        <div class="relationWay">
          <img src="../../assets/about/email.png" class="relationIcon"/>
          <p class="relationWayTitle">电子邮箱</p>
          <p class="relationWayContent">market@opencar.cc</p>
        </div>
        <div class="relationWay">
          <img src="../../assets/about/weichat.png" class="relationIcon"/>
          <p class="relationWayTitle">微信公众号</p>
          <p class="relationWayContent">微信搜索“任马停”</p>
          <p class="watchErcode" @click="showErcode">查看二维码></p>
          <div class="wxErcodeBox" v-show="showWxErcode" @click="hiddenErcode">
            <img src="../../assets/footer/wxErcode.png" class="wxIcon"/>
          </div>
        </div>
      </div>
      <div class="addressBox">
        <p class="addressTitle">公司地址：</p>
        <p class="addressContent">杭州市西湖区三墩镇西园九路3号光紫金科创中心1号楼6层601室</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Relation',
  data: function () {
    return {
      showWxErcode: false
    }
  },
  methods: {
    showErcode: function () {
      this.showWxErcode = true
    },
    hiddenErcode: function () {
      this.showWxErcode = false
    }
  }
}
</script>

<style scoped>
#totalBox{
  width: 100%;
  height: 680px;
}
.relationBox{
  width: 1200px;
  height: 680px;
  margin: 0 auto;
  padding-top: 22px;
  padding-top: 48px;
}
.relationTitle{
  font-size:40px;
  font-weight:bold;
  color:rgba(35,24,21,1);
}
.relationWayBox{
  width: 1200px;
  margin-top: 64px;
  height: 340px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.relationWay{
  width: 380px;
  height: 340px;
  border:1px solid rgba(223,223,223,1);
  box-shadow:0px 2px 10px 0px rgba(35,24,21,0.06);
  padding-top: 47px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  position: relative;
}
.relationIcon{
  width:96px;
  height:96px;
}
.relationWayTitle{
  font-size:30px;
  margin-top: 35px;
  font-weight:bold;
  color:rgba(35,24,21,1);
}
.relationWayContent{
  font-size:26px;
  margin-top: 15px;
  font-weight:400;
  color:rgba(35,24,21,1);
}
.watchErcode{
  font-size:20px;
  font-weight:400;
  color:rgba(12,137,24,1);
  margin-top: 12px;
  cursor: pointer;
}
.addressBox{
  width:100%;
  height:120px;
  background:rgba(250,250,250,1);
  margin-top: 33px;
  text-align: left;
  padding-left: 289px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.addressTitle{
  font-size:22px;
  font-weight:400;
  color:rgba(117,117,117,1);
}
.addressContent{
  font-size:26px;
  font-weight:400;
  color:rgba(35,24,21,1);
  margin-top: 15px;
}
.wxErcodeBox{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(000,000,000,0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.wxIcon{
  width: 240px;
  height: 240px;
}
</style>



// WEBPACK FOOTER //
// src/components/about/Relation.vue